import { isRootPath } from '~/utils/authRoutes';
import { hydrationSafeNavigateTo } from '~/utils/hydrationSafeNavigation';

/**
 * 根路徑導向
 *
 * `/` 與 `/zh-TW` 這類只有語系前綴的路徑本身沒有內容，一律送到 dashboard。
 * 認證判斷不在這裡 —— auth.global 會先跑（global middleware 依檔名排序），
 * 未登入時根本走不到這一支。
 */
export default defineNuxtRouteMiddleware((to) => {
  if (!isRootPath(to.path)) {
    return;
  }

  const dashboardPath = useLocalePath()('/dashboard');

  // external: false —— 伺服器端明確關閉，避免重複設置 headers
  // hydrationSafeNavigateTo —— hydration 期間不直接跳，否則會用 dashboard 的 vnode 樹
  // 去 hydrate 上一頁的 DOM（見 utils/hydrationSafeNavigation.ts）
  return hydrationSafeNavigateTo(useNuxtApp(), dashboardPath, { external: false });
});
